import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=d02da35c&scoped=true"
import script from "./Act.js?vue&type=script&lang=js&external"
export * from "./Act.js?vue&type=script&lang=js&external"
import style0 from "./Act.scss?vue&type=style&index=0&id=d02da35c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02da35c",
  null
  
)

export default component.exports